// Extracted from React docs: https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
import { useEffect, useRef } from "react";
export function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    if (ref.current != value) {
      ref.current = value;
    }
  });
  return ref.current;
}